export * from './language.response';
//# sourceMappingURL=index.js.map